import { FetchPolicy } from '@apollo/client';
import { CaseType } from '@rapid-recovery-agency-inc/insightt-shared';
import { CameraHitDetailListV2 } from '@rapid-recovery-agency-inc/insightt-graphql';

export interface FetchRepoHitListClientsParams {
  branchId: number;
  date: string;
  timezone: string;
}

export type FetchPcymCompanyStatsParams = {
  year: number;
  timezoneOffset: number;
};

export type FetchYtdCompanyStatsParams = {
  date: string;
  timezoneOffset: number;
};

export type FetchTopAgentsParams = {
  startDate: string;
  endDate: string;
  timezoneOffset?: number;
  branchId: number;
  startDateTime?: string;
  endDateTime?: string;
  fetchPolicy?: FetchPolicy;
};

export type FetchTopSpottersParams = {
  startDate: string;
  endDate: string;
  timezoneOffset: number;
};

export type FetchDailyViewStatsParams = {
  date: string;
  timezoneOffset: number;
  branchId: number;
  timeStamp?: number;
};

export type FetchMtdRepossessedParams = {
  startDate: string;
  endDate: string;
  mode: string;
  branchId: number;
  fetchPolicy?: FetchPolicy;
};

export type FetchMtdAssignedParams = {
  startDate: string;
  endDate: string;
  branchId: number;
  fetchPolicy?: FetchPolicy;
};

// export type FetchMtdYtdCompanyUncaterogizedParams = {
//   timezoneOffset: number;
// };

export type FetchNewTopAgentsParams = {
  startDate: string;
  endDate: string;
  branchId: number | null;
};

export interface LocationModalStateLiveHits {
  status: boolean;
  data: CameraHitDetailListV2 | null;
}

export interface LocationDataInterface extends CaseType {
  repoLat?: number;
  repoLng?: number;
  repoAddress?: string;
  repo_address?: string;
  orderType?: string;
  status?: string;
  yearMakeModel?: string;
  vin?: string;
}

export enum DailyMapType {
  TOTAL_REPOSESSIONS = 'total-repossessions',
  SPOTTED = 'spotted',
  SPOTTED_NOT_SECURED = 'spotted-not-secured',
}
